import { memo } from 'react';
import { ImageLoader } from './ImageLoader';
import { ImageLazyLoader } from './ImageLazyLoader';
import type { FC } from 'react';

export interface ImageProps {
  src: string;
  alt?: string;
  srcSet?: string;
  onLoad?: () => void;
  width?: string | number | string[] | number[];
  height?: string | number | string[] | number[];
  lazy?: boolean;
  cover?: boolean;
  [key: string]: unknown;
}

export const Image: FC<ImageProps> = memo(
  ({ alt = 'alt', lazy = false, cover = true, ...rest }: ImageProps) => {
    const InnerImage = lazy ? ImageLazyLoader : ImageLoader;
    return <InnerImage alt={alt} cover={cover} {...rest} />;
  }
);

Image.displayName = 'Image';
